<template>
  <v-container class="text-center mt-12">
    <v-row justify="center">
      <v-col cols="12">
        <h1 class="display-1 font-weight-bold">404</h1>
        <p class="text-subtitle-1">La página que buscas no existe.</p>
        <v-btn color="primary" to="/">Ir al Inicio</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "NotFoundComponent",
};
</script>

<style scoped>
h1 {
  font-size: 6rem;
}
</style>
